import { get } from '@/tools/http';
import Vue from 'vue';

const registryLoading = {};

export default {
    namespaced: true,

    state: {
        registry: {},
        registryItems: {},
    },

    mutations: {
        setRegistryItems: (state, { type, items }) => {
            if (state.registry[type] === undefined) {
                const copy = { ...state.registry };
                copy[type] = items;
                state.registry = copy;
            } else {
                state.registry[type] = items;
            }
            items.forEach(item => {
                Vue.set(state.registryItems, item.id, item.field_value);
            });
        },
        addRegistryItems: (state, { type, items }) => {
            if (state.registry[type] === undefined) {
                const copy = { ...state.registry };
                copy[type] = items;
                state.registry = copy;
            } else {
                state.registry[type] = [...state.registry[type], ...items];
            }
            items.forEach(item => {
              if(item) {
                Vue.set(state.registryItems, item.id, item.field_value);
              }
            });
        },
    },

    actions: {
        loadRegistryItems: async (ctx, { type, withDeleted = false, withMeta = false, reload = true }) => {
            if (!reload && state.registry[type] !== undefined && state.registry[type].length) {
                return;
            }

            if (registryLoading[type] === true) {
                // Prevent and await registry loading if other loading was called in same time
                await new Promise((resolve) => {
                    const interval = setInterval(async () => {
                        // Load registry if previous got error
                        if (registryLoading[type] === -1) {
                            await ctx.dispatch('loadRegistryItems', { type, withDeleted, withMeta });
                            resolve();
                        } else if (registryLoading[type] === false) {
                            clearInterval(interval);
                            resolve();
                        }
                    }, 100);
                });

                return;
            }

            registryLoading[type] = true;

            try {
                const query = [];

                if (withDeleted) {
                    query.push('is_deleted=true');
                }

                if (withMeta) {
                    query.push('with_meta=true');
                }

                const items = await get('data', `catalog/get/${type}?${query.join('&')}`);

                ctx.commit('setRegistryItems', {
                    type,
                    items,
                });

                registryLoading[type] = false;
            } catch (e) {
                console.error(e);
                registryLoading[type] = -1;
            }
        },
        loadRegistrySearchItems: async ({ commit }, { type, query = '', limit = 100, offset = 0 }) => {
            try {
                let queryString = '';
                if (query.length > 1) {
                    queryString = `&q=${query}`;
                }
                return await get('data', `catalog/search/${type}?limit=${limit}&offset=${offset}${queryString}`);
            } catch (e) {
                console.error(e);
            }
        },
        loadRegistryItemsByIDs: async ({commit}, { type, ids }) => {
            ids = ids.filter(
                (value, index, arr) => {
                    return value && arr.indexOf(value) === index;
                }
            );

            if (!ids || !ids.length) {
                return;
            }

            try {
                const items = await Promise.all(
                    ids.map(
                        id => get('data', `element/${id}`)
                    )
                );

                commit('addRegistryItems', {type, items});
            } catch (e) {
                console.error(e);
            }
        },
    },

    getters: {
        getRegistry: state => state.registry,
        getRegistryItems: state => (type) => (state.registry[type] || []).filter(v => v ? !v.is_deleted : ""),
        getRegistryItemById: state => (id) => state.registryItems[id],
        getRegistryValueById: state => (id) => {
            const value = state.registryItems[+id];
            return value || '';
        },
    },
};
